var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.files), function(file, index) {
    return _c('div', {
      key: index,
      class: _vm.theme.fileUploaded
    }, [_c('div', [_c('v-icon-button', {
      attrs: {
        "grey": ""
      },
      on: {
        "click": function($event) {
          _vm.$emit('remove', {
            file: file,
            index: index
          })
        }
      }
    }, [_vm._v("\n                cancel\n            ")]), _vm._v(" "), _c('v-text', [_c('v-link', [_vm._v("\n                    " + _vm._s(file.name) + "\n                ")])], 1)], 1)])
  }), _vm._v(" "), _c('div', {
    class: _vm.classes
  }, [_c('input', {
    class: _vm.theme.inputRaw,
    attrs: {
      "multiple": _vm.multiple,
      "disabled": _vm.disabled,
      "name": _vm.name,
      "type": "file"
    },
    on: {
      "change": _vm.handleChange
    }
  }), _vm._v(" "), _c('v-text', {
    attrs: {
      "nowrap": ""
    }
  }, [_c('v-icon-button', {
    attrs: {
      "grey": ""
    }
  }, [_vm._v("\n                file_upload\n            ")]), _vm._v(" "), _c('v-text', {
    attrs: {
      "nowrap": ""
    }
  }, [_c('v-link', {
    attrs: {
      "to": "javascript:;"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.label) + "\n                ")])], 1)], 1), _vm._v(" "), (_vm.loader) ? _c('div', {
    class: _vm.theme.loader
  }, [_c('v-spinner')], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isErrorString) ? _c('div', {
    class: [_vm.theme.caption, _vm.theme.hasError]
  }, [_vm._t("error", [_vm._v(_vm._s(_vm.error))], {
    error: _vm.error
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.error), function(err, filename, index) {
    return (_vm.isErrorCollection) ? _c('div', {
      key: index,
      class: [_vm.theme.caption, _vm.theme.hasError]
    }, [_vm._v(_vm._s(filename) + ": " + _vm._s(err))]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    class: _vm.theme.caption
  }, [_vm._t("caption", [_vm._v(_vm._s(_vm.caption))], {
    caption: _vm.caption
  })], 2)], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a79f47d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/FileUploader/FileUploader.vue
// module id = 560
// module chunks = 0